import React, { useEffect, useState } from 'react';

import { DateTime } from 'luxon';
import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import useTimeout from 'use-timeout';

import { constants } from '@nhl/formatter-utilities';
import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import useInterval from '@use-it/interval';

import { puckAndPlayerTractionActions } from '../../../redux/ducks/puckAndPlayerTracking';
import { commonMessages } from '../../../utility/commonMessages';
import Scoreboard from '../../components/scoreboard';

// @ts-ignore
import logo from './NHL_Edge_WhiteBG.png';
import TrackingDataContainer from './components/trackingDataContainer';

import './styles';

const PuckAndPlayerTracking = () => {
    const dispatch = useDispatch();
    const { game, pptData, teamData } = useSelector(({ puckAndPlayerTracking }) => puckAndPlayerTracking);
    const [isInitialLoadComplete, setInitialLoadComplete] = useState(false);
    const [gameRefreshInterval, setGameRefreshInterval] = useState<null | number>(null);
    const [gameStartTime, setGameStartTime] = useState<null | number>(null);

    const fetchGameData = () => {
        const queryParams = queryString.parse(window.location.search);
        const gameId = { gameId: queryParams.id };
        dispatch(puckAndPlayerTractionActions.requestPPTData(gameId));
    };

    useEffect(() => {
        fetchGameData();
    }, []);

    useEffect(() => {
        if (!teamData.isEmpty) {
            setInitialLoadComplete(true);
        }
    }, [pptData]);

    useEffect(() => {
        if (game) {
            if (game.gameStateId >= constants.PREGAME && game.gameStateId < constants.HARD_FINAL) {
                setGameRefreshInterval(3000);
            } else if (gameRefreshInterval) {
                setGameRefreshInterval(null);
            }
        }
    }, [game]);

    useEffect(() => {
        if (game?.gameStateId < constants.PREGAME) {
            setGameStartTime(
                DateTime.fromISO(game.easternStartTime, { zone: constants.ET_TIMEZONE })
                    .toLocal()
                    .diff(DateTime.local())
                    .valueOf(),
            );
        }
    }, [game]);

    // if we are looking at a live game just refresh every 10 seconds
    useInterval(fetchGameData, gameRefreshInterval);
    // otherwise we'll set a timeout for when the game starts, at which point the game should be either live or in
    // pre-game and can start using the polling interval.
    useTimeout(fetchGameData, gameStartTime);

    return (
        <LoadingDisplay isLoading={!isInitialLoadComplete}>
            <div className="logo-container">
                <img className="edge-logo" src={logo} alt="NHL Edge" />
            </div>
            {game && teamData?.length > 0 && <Scoreboard game={game} teamData={teamData} />}
            {pptData.length === 0 ? (
                <div className="noData">
                    <FormattedMessage {...commonMessages.misc.noData} />
                </div>
            ) : game?.gameStateId > constants.PREGAME ? (
                <TrackingDataContainer />
            ) : (
                <div className="noData">
                    <FormattedMessage
                        defaultMessage="Data will be available once the game has started."
                        description="A message that displays before a game has started"
                    />
                </div>
            )}
        </LoadingDisplay>
    );
};

export { PuckAndPlayerTracking as Component };
